import Account from '@/pages/Account/Template'
import Dashboard from '@/pages/Account/Dashboard'
import Settings from '@/pages/Account/Settings'
import Groups from '@/pages/Account/Groups'
import Group from '@/pages/Account/Groups/Group'
import Sellpoints from '@/pages/Account/Sellpoints'
import Sellpoint from '@/pages/Account/Sellpoint/Template'
import Categories from '@/pages/Account/Sellpoint/Categories'
import Category from '@/pages/Account/Sellpoint/Category'
import Products from '@/pages/Account/Sellpoint/Products'
import Product from '@/pages/Account/Sellpoint/Product'
import SellpointOrders from '@/pages/Account/Sellpoint/Orders'
import SellpointSettings from '@/pages/Account/Sellpoint/Settings'
//
import AddBusiness from '@/pages/Account/Sellpoint/Components/AddBusiness'
import AddCategory from '@/pages/Account/Sellpoint/Components/AddCategory'
import AddProduct from '@/pages/Account/Sellpoint/Components/AddProduct'
import GenerateTransferPayment from '@/pages/Account/Sellpoint/Components/GenerateTransferPayment'
//
import SellpointTransactions from '@/pages/Account/Sellpoint/Settings/SellpointTransactions'
import SellpointPayments from '@/pages/Account/Sellpoint/Settings/SellpointPayments'
import SellpointShipping from '@/pages/Account/Sellpoint/Settings/SellpointShipping'
import SellpointDiscounts from '@/pages/Account/Sellpoint/Settings/SellpointDiscounts'
import SellpointRewards from '@/pages/Account/Sellpoint/Settings/SellpointRewards'
//
import ProductTypes  from '@/pages/Account/Sellpoint/Product/ProductTypes'
import ProductOrders  from '@/pages/Account/Sellpoint/Product/ProductOrders'
import ProductReviews  from '@/pages/Account/Sellpoint/Product/ProductReviews'
import ProductSettings  from '@/pages/Account/Sellpoint/Product/ProductSettings'
import ProductAddons  from '@/pages/Account/Sellpoint/Product/ProductAddons'
import ProductDiscounts  from '@/pages/Account/Sellpoint/Product/ProductDiscounts'
import ProductShipping  from '@/pages/Account/Sellpoint/Product/ProductShipping'
//
import SellpointOrderRequest from '@/pages/Account/Sellpoint/Orders/OrderDetailsRequest'

//
export default {
    path: '',
    component: Account,
    children: [
      {
        path: '/account',
        name: 'Account',
        component: Account,
      },
      {
        path: '/account/businesses',
        name: 'Sellpoints',
        component: Sellpoints,
      },
      {
        path: '/account/business',
        name: 'Sellpoint',
        component: Sellpoint,
        children: [
          {
            path: '',
            name: 'AccountSellpoint',
            component: Sellpoint,
          },
          {
            path: '/account/business/categories',
            name: 'AccountSellpointCategories',
            component: Categories,
          },
          {
            path: '/account/business/category',
            name: 'AccountSellpointCategory',
            component: Category,
          },
          {
            path: '/account/business/products',
            name: 'AccountSellpointProducts',
            component: Products,
          },
          {
            path: '/account/business/product',
            component: Product,
            children: [
              {
                path: '',
                name: 'AccountSellpointProduct',
                component: Product,
              },
              {
                path: '/account/business/product/types',
                name: 'ProductTypes',
                component: ProductTypes,
              },
              {
                path: '/account/business/product/orders',
                name: 'ProductOrders',
                component: ProductOrders,
              },
              {
                path: '/account/business/product/reviews',
                name: 'ProductReviews',
                component: ProductReviews,
              },
              {
                path: '/account/business/product/settings',
                name: 'ProductSettings',
                component: ProductSettings,
              },
              {
                path: '/account/business/product/addons',
                name: 'ProductAddons',
                component: ProductAddons,
              },
              {
                path: '/account/business/product/discounts',
                name: 'ProductDiscounts',
                component: ProductDiscounts,
              },
              {
                path: '/account/business/product/shipping',
                name: 'ProductShipping',
                component: ProductShipping,
              }
            ]
          },
          {
            path: '/account/business/orders',
            name: 'AccountSellpointOrders',
            component: SellpointOrders,
          },
          {
            path: '/account/business/orders/:business/:ref',
            name: 'AccountSellpointOrder',
            component: SellpointOrderRequest,
          },
          {
            path: '/account/business/settings',
            name: 'AccountSellpointSettings',
            component: SellpointSettings,
          },
           //
      
          {
            path: '/account/business/newproduct',
            name: 'AddNewProduct',
            component: AddProduct,
          },
          {
            path: '/account/business/newcategory',
            name: 'AddNewCategory',
            component: AddCategory,
          },
          //
          {
            path: '/account/business/transactions',
            name: 'BusinessTransactions',
            component: SellpointTransactions,
          },
          {
            path: '/account/business/shipping',
            name: 'BusinessShipping',
            component: SellpointShipping,
          },
          {
            path: '/account/business/payments',
            name: 'BusinessPayments',
            component: SellpointPayments,
          },
          {
            path: '/account/business/discounts',
            name: 'BusinessDiscounts',
            component: SellpointDiscounts,
          },
          {
            path: '/account/business/rewards',
            name: 'BusinessRewards',
            component: SellpointRewards,
          },
          {
            path: '/account/business/generatetransferpayment',
            name: 'GenerateTransferPayment',
            component: GenerateTransferPayment,
          },
        ]   
      },
      {
        path: '/account/business/newbusiness',
        name: 'AddNewBusiness',
        component: AddBusiness,
      },{
        path: '/account/business/newbusiness/agent',
        name: 'AddNewBusinessByAgent',
        component: AddBusiness,
      },
      {
        path: '/account/groups',
        name: 'AccountGroups',
        component: Groups,
      },
      {
        path: '/account/group/:ref',
        name: 'AccountGroup',
        component: Group,
      },
      {
        path: '/account/settings',
        name: 'AccountSettings',
        component: Settings,
      },
     
    ]
}

// import Account from '@/pages/Account/Template'
// import Sellpoint from '@/pages/Account/Sellpoint'
// import Settings from '@/pages/Account/Settings'
// export default {
//     path: '',
//     component: Account,
//     children: [
//       {
//         path: '/account',
//         name: 'Account',
//         component: Account,
//       },
//       {
//         path: '/account/business',
//         name: 'AccountSellpoint',
//         component: Sellpoint,
//       },
//       {
//         path: '/account/settings',
//         name: 'Settings',
//         component: Settings,
//       },
//     ]
// }


// WEBPACK FOOTER //
// ./src/router/account.js